var map = {
	"./crm/crm.module": [
		778,
		0
	],
	"./dashboard/dashboard.module": [
		779,
		3
	],
	"./pages/pages.module": [
		780,
		2
	],
	"./proyectos/proyectos.module": [
		781,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 432;



//////////////////
// WEBPACK FOOTER
// ./src async
// module id = 432
// module chunks = 5